const seeds = {
  "title": "",
  "description": "",
  "groups": [
    {
      "title": "Integration API",
      "permalink": "g~integration~api",
      "description": "API for external integration",
      "resources": [
        {
          "title": "Colors List",
          "permalink": "r~integration~api~colors~list",
          "description": "",
          "transitions": [
            {
              "title": "Authentication",
              "permalink": "t~integration~api~colors~list~get~integration~api~colors~auth",
              "method": "GET",
              "path": "/integration_api/colors   [auth]",
              "meta": {
                "resource": {
                  "title": "Colors List",
                  "permalink": "r~integration~api~colors~list"
                },
                "group": {
                  "title": "Integration API",
                  "permalink": "g~integration~api"
                }
              }
            },
            {
              "title": "List Colors",
              "permalink": "t~integration~api~colors~list~get~integration~api~colors",
              "method": "GET",
              "path": "/integration_api/colors",
              "meta": {
                "resource": {
                  "title": "Colors List",
                  "permalink": "r~integration~api~colors~list"
                },
                "group": {
                  "title": "Integration API",
                  "permalink": "g~integration~api"
                }
              }
            }
          ]
        },
        {
          "title": "Nameplates List",
          "permalink": "r~integration~api~nameplates~list",
          "description": "",
          "transitions": [
            {
              "title": "Authentication",
              "permalink": "t~integration~api~nameplates~list~get~integration~api~nameplates~auth",
              "method": "GET",
              "path": "/integration_api/nameplates   [auth]",
              "meta": {
                "resource": {
                  "title": "Nameplates List",
                  "permalink": "r~integration~api~nameplates~list"
                },
                "group": {
                  "title": "Integration API",
                  "permalink": "g~integration~api"
                }
              }
            },
            {
              "title": "List Nameplates",
              "permalink": "t~integration~api~nameplates~list~get~integration~api~nameplates",
              "method": "GET",
              "path": "/integration_api/nameplates",
              "meta": {
                "resource": {
                  "title": "Nameplates List",
                  "permalink": "r~integration~api~nameplates~list"
                },
                "group": {
                  "title": "Integration API",
                  "permalink": "g~integration~api"
                }
              }
            }
          ]
        },
        {
          "title": "Vehicles Integration",
          "permalink": "r~integration~api~vehicles~integration",
          "description": "",
          "transitions": [
            {
              "title": "Authentication",
              "permalink": "t~integration~api~vehicles~integration~post~integration~api~vehicles~auth",
              "method": "POST",
              "path": "/integration_api/vehicles   [auth]",
              "meta": {
                "resource": {
                  "title": "Vehicles Integration",
                  "permalink": "r~integration~api~vehicles~integration"
                },
                "group": {
                  "title": "Integration API",
                  "permalink": "g~integration~api"
                }
              }
            },
            {
              "title": "Create Vehicle",
              "permalink": "t~integration~api~vehicles~integration~post~integration~api~vehicles",
              "method": "POST",
              "path": "/integration_api/vehicles",
              "meta": {
                "resource": {
                  "title": "Vehicles Integration",
                  "permalink": "r~integration~api~vehicles~integration"
                },
                "group": {
                  "title": "Integration API",
                  "permalink": "g~integration~api"
                }
              }
            }
          ]
        }
      ]
    },
    {
      "title": "Management API",
      "permalink": "g~management~api",
      "description": "API for tools managed by Raffine",
      "resources": [
        {
          "title": "Companies",
          "permalink": "r~management~api~companies",
          "description": "",
          "transitions": [
            {
              "title": "List Companies",
              "permalink": "t~management~api~companies~get~management~api~companies",
              "method": "GET",
              "path": "/management_api/companies",
              "meta": {
                "resource": {
                  "title": "Companies",
                  "permalink": "r~management~api~companies"
                },
                "group": {
                  "title": "Management API",
                  "permalink": "g~management~api"
                }
              }
            }
          ]
        }
      ]
    },
    {
      "title": "Models",
      "permalink": "g~models",
      "description": "CRUD actions for all exisiting DB models",
      "resources": [
        {
          "title": "Brand",
          "permalink": "r~models~brand",
          "description": "Represents Brand like Jaguar or Land Rover",
          "transitions": [
            {
              "title": "Get All Brands",
              "permalink": "t~models~brand~get~brands",
              "method": "GET",
              "path": "/brands",
              "meta": {
                "resource": {
                  "title": "Brand",
                  "permalink": "r~models~brand"
                },
                "group": {
                  "title": "Models",
                  "permalink": "g~models"
                }
              }
            },
            {
              "title": "Show one brand",
              "permalink": "t~models~brand~get~brands~id",
              "method": "GET",
              "path": "/brands/{id}",
              "meta": {
                "resource": {
                  "title": "Brand",
                  "permalink": "r~models~brand"
                },
                "group": {
                  "title": "Models",
                  "permalink": "g~models"
                }
              }
            },
            {
              "title": "Create Brand",
              "permalink": "t~models~brand~post~brands",
              "method": "POST",
              "path": "/brands",
              "meta": {
                "resource": {
                  "title": "Brand",
                  "permalink": "r~models~brand"
                },
                "group": {
                  "title": "Models",
                  "permalink": "g~models"
                }
              }
            },
            {
              "title": "Update Brand",
              "permalink": "t~models~brand~patch~brands~id",
              "method": "PATCH",
              "path": "/brands/{id}",
              "meta": {
                "resource": {
                  "title": "Brand",
                  "permalink": "r~models~brand"
                },
                "group": {
                  "title": "Models",
                  "permalink": "g~models"
                }
              }
            },
            {
              "title": "Delete Brand",
              "permalink": "t~models~brand~delete~brands~id",
              "method": "DELETE",
              "path": "/brands/{id}",
              "meta": {
                "resource": {
                  "title": "Brand",
                  "permalink": "r~models~brand"
                },
                "group": {
                  "title": "Models",
                  "permalink": "g~models"
                }
              }
            }
          ]
        },
        {
          "title": "ButtonSet",
          "permalink": "r~models~buttonset",
          "description": "Object representing `ButtonSet` model.\n\n# ButtonSet Attributes\n\n| attr                | type          | required       | example                        | notes                                        |\n|---------------------|---------------|----------------|--------------------------------|----------------------------------------------|\n| `label`             | string        | yes            | \"Main set\"                     | ButtonSet name                               |\n| `buttons`           | array         | no             | [{\"label\": \"Click here\", ...}] | Nested buttons attributes (see table below)  |\n| `button_set_type`   | string        | yes            | \"extended\"                     | Can be either \"standard\" or \"extended\"       |\n| `reservation_fee`   | decimal(18,2) | if extended(*) | 2000.00                        | Reservation fee                              |\n| `financing_options` | array         | if extended(*) | [\"cash\"]                       | Multiselect - array can contain some or all of following values: ['cash', 'lease', 'rent']  |\n\n(*) - `reservation_fee` and `financing_options` attributes are required only, if `button_set_type` value is set to `extended`\n\n# Button Attributes\n\n| attr          | type   | required | example        | notes                                        |\n|---------------|--------|----------|----------------|----------------------------------------------|\n| label         | string | yes      | \"Click here\"   | Button label displayed to user               |\n| target        | string | yes      | \"john@doe.com\" | Target URL, phone, code (embed) etc.         |\n| button_type   | enum   | yes      | \"secondary\"    | A type of a button (primary/secondary)       |\n| target_action | enum   | yes      | \"self\"         | Defines what happens on button click         |\n| target_type   | enum   | yes      | \"email\"        | Defines a type of a target action            |\n\n## Button type\n\nButton type can be either `primary` or `secondary`. Please note that **only 1 primary button is allowed for a company**. Secondary buttons are optional.\n\n## Target action\n\nDefines what happens when the button is clicked. Accepted values:\n\n- `self` - executes defined action in current browser's tab\n\n- `new_tab` - executes defined action in a new tab\n\n- `modal` - executes defined action in a modal\n\n## Target type\n\nDefines a type of a target action. Allowed values:\n\n- `email`\n\n- `url`\n\n- `embed`\n\n- `phone`",
          "transitions": [
            {
              "title": "Request UUID header",
              "permalink": "t~models~buttonset~get~buttons~header",
              "method": "GET",
              "path": "/buttons?header",
              "meta": {
                "resource": {
                  "title": "ButtonSet",
                  "permalink": "r~models~buttonset"
                },
                "group": {
                  "title": "Models",
                  "permalink": "g~models"
                }
              }
            },
            {
              "title": "Get All ButtonSets",
              "permalink": "t~models~buttonset~get~button~sets",
              "method": "GET",
              "path": "/button_sets",
              "meta": {
                "resource": {
                  "title": "ButtonSet",
                  "permalink": "r~models~buttonset"
                },
                "group": {
                  "title": "Models",
                  "permalink": "g~models"
                }
              }
            },
            {
              "title": "Get one ButtonSet",
              "permalink": "t~models~buttonset~get~button~sets~id",
              "method": "GET",
              "path": "/button_sets/{id}",
              "meta": {
                "resource": {
                  "title": "ButtonSet",
                  "permalink": "r~models~buttonset"
                },
                "group": {
                  "title": "Models",
                  "permalink": "g~models"
                }
              }
            },
            {
              "title": "Create ButtonSet",
              "permalink": "t~models~buttonset~post~button~sets",
              "method": "POST",
              "path": "/button_sets",
              "meta": {
                "resource": {
                  "title": "ButtonSet",
                  "permalink": "r~models~buttonset"
                },
                "group": {
                  "title": "Models",
                  "permalink": "g~models"
                }
              }
            },
            {
              "title": "Update ButtonSet",
              "permalink": "t~models~buttonset~patch~button~sets~id",
              "method": "PATCH",
              "path": "/button_sets/{id}",
              "meta": {
                "resource": {
                  "title": "ButtonSet",
                  "permalink": "r~models~buttonset"
                },
                "group": {
                  "title": "Models",
                  "permalink": "g~models"
                }
              }
            },
            {
              "title": "Delete ButtonSet",
              "permalink": "t~models~buttonset~delete~button~sets~id",
              "method": "DELETE",
              "path": "/button_sets/{id}",
              "meta": {
                "resource": {
                  "title": "ButtonSet",
                  "permalink": "r~models~buttonset"
                },
                "group": {
                  "title": "Models",
                  "permalink": "g~models"
                }
              }
            }
          ]
        },
        {
          "title": "Color",
          "permalink": "r~models~color",
          "description": "Object representing `Vehicle` exterior color.\n\n# Attributes\n\n| attr      | type   | reqiured | example       | notes                                        |\n|-----------|--------|----------|---------------|----------------------------------------------|\n| name      | string | yes      | \"Firenze Red\" | Display name of the color showed to end user |\n| canonical | enum   | yes      | \"red\"         | Canonical color mapping, used for filtering  |\n\n# Canonical value\n\nBrand Color name can not be very descriptive, also local retailers sometimes want to add their own colors named in\nlocal language like \"Niebieski\".\n\nOn the other hand customers looking for a vehicle do not want to find \"Fuji White\" vehicles. They are interested in\nselecting actuall color like brown.\n\nThats why all Colors in the system require to be mapped to predetermined color pallet through the `canonical` attribute.\n\nThis attribute is strongly validated againts list determined by system and only available options are:\n\n- white\n\n- black\n\n- silver\n\n- gray\n\n- red\n\n- green\n\n- bronze\n\n- blue\n\n- yellow\n\n- orange",
          "transitions": [
            {
              "title": "Request UUID header",
              "permalink": "t~models~color~get~colors~header",
              "method": "GET",
              "path": "/colors?header",
              "meta": {
                "resource": {
                  "title": "Color",
                  "permalink": "r~models~color"
                },
                "group": {
                  "title": "Models",
                  "permalink": "g~models"
                }
              }
            },
            {
              "title": "Get All Colors",
              "permalink": "t~models~color~get~colors",
              "method": "GET",
              "path": "/colors",
              "meta": {
                "resource": {
                  "title": "Color",
                  "permalink": "r~models~color"
                },
                "group": {
                  "title": "Models",
                  "permalink": "g~models"
                }
              }
            },
            {
              "title": "Show one color",
              "permalink": "t~models~color~get~colors~id",
              "method": "GET",
              "path": "/colors/{id}",
              "meta": {
                "resource": {
                  "title": "Color",
                  "permalink": "r~models~color"
                },
                "group": {
                  "title": "Models",
                  "permalink": "g~models"
                }
              }
            },
            {
              "title": "Create Color",
              "permalink": "t~models~color~post~colors",
              "method": "POST",
              "path": "/colors",
              "meta": {
                "resource": {
                  "title": "Color",
                  "permalink": "r~models~color"
                },
                "group": {
                  "title": "Models",
                  "permalink": "g~models"
                }
              }
            },
            {
              "title": "Update Color",
              "permalink": "t~models~color~patch~colors~id",
              "method": "PATCH",
              "path": "/colors/{id}",
              "meta": {
                "resource": {
                  "title": "Color",
                  "permalink": "r~models~color"
                },
                "group": {
                  "title": "Models",
                  "permalink": "g~models"
                }
              }
            },
            {
              "title": "Delete Color",
              "permalink": "t~models~color~delete~colors~id",
              "method": "DELETE",
              "path": "/colors/{id}",
              "meta": {
                "resource": {
                  "title": "Color",
                  "permalink": "r~models~color"
                },
                "group": {
                  "title": "Models",
                  "permalink": "g~models"
                }
              }
            }
          ]
        },
        {
          "title": "Company",
          "permalink": "r~models~company",
          "description": "Represents Company data.\n\nAll API actions are to be executed in the context of selected Company.\n\n#### `uuid` parameter\n\nCompany object is by default equiped with randomly generate `uuid` attribute.\nIt's purpose is to be Company unique indentifier used in `X-Company-UUID` header\nto filter all action and resources in the API requests.\n\n*NOTE:* `uuid` value cannot be modified directly through the api calls.\n\n#### Current Company\n\nAll API Actions performed on Companies are scoped to current company instance.\nThe current company is found based on the `X-Company-UUID` header value.\n\nDue to this the some Company controller actions and URLs were changed.\n\n| Verb  | Old URL    | New URL         | Behaviour (after changes)                         |\n|-------|------------|-----------------|---------------------------------------------------|\n| GET   | /companies | (same)          | It list only current company and its Subcompanies |\n| POST  | /companies | (same)          | Creates compnany owned by current company         |\n| GET   | /company   | /companies/{id} | Fetches Current Company                           |\n| PATCH | /company   | /companies/{id} | Updates Current Company                           |\n\nFor easier transition both new and old URLs are working simultanously.\n\nCompany Deleting endpoit was turned *off*",
          "transitions": [
            {
              "title": "Request UUID header",
              "permalink": "t~models~company~get~companys~header",
              "method": "GET",
              "path": "/companys?header",
              "meta": {
                "resource": {
                  "title": "Company",
                  "permalink": "r~models~company"
                },
                "group": {
                  "title": "Models",
                  "permalink": "g~models"
                }
              }
            },
            {
              "title": "Get Companies in network",
              "permalink": "t~models~company~get~companies",
              "method": "GET",
              "path": "/companies",
              "meta": {
                "resource": {
                  "title": "Company",
                  "permalink": "r~models~company"
                },
                "group": {
                  "title": "Models",
                  "permalink": "g~models"
                }
              }
            },
            {
              "title": "Get Available Time Zones",
              "permalink": "t~models~company~get~companies~time~zones~country~code",
              "method": "GET",
              "path": "/companies/time_zones/{country_code}",
              "meta": {
                "resource": {
                  "title": "Company",
                  "permalink": "r~models~company"
                },
                "group": {
                  "title": "Models",
                  "permalink": "g~models"
                }
              }
            },
            {
              "title": "Show current company",
              "permalink": "t~models~company~get~company",
              "method": "GET",
              "path": "/company",
              "meta": {
                "resource": {
                  "title": "Company",
                  "permalink": "r~models~company"
                },
                "group": {
                  "title": "Models",
                  "permalink": "g~models"
                }
              }
            },
            {
              "title": "Create Sub Company",
              "permalink": "t~models~company~post~companies",
              "method": "POST",
              "path": "/companies",
              "meta": {
                "resource": {
                  "title": "Company",
                  "permalink": "r~models~company"
                },
                "group": {
                  "title": "Models",
                  "permalink": "g~models"
                }
              }
            },
            {
              "title": "Update current Company",
              "permalink": "t~models~company~patch~company",
              "method": "PATCH",
              "path": "/company",
              "meta": {
                "resource": {
                  "title": "Company",
                  "permalink": "r~models~company"
                },
                "group": {
                  "title": "Models",
                  "permalink": "g~models"
                }
              }
            }
          ]
        },
        {
          "title": "Listing",
          "permalink": "r~models~listing",
          "description": "Object representing `Vehicle` list to be displayed on site.\n\n# Attributes\n\n| attr      | type   | reqiured | example       | notes                                              |\n|-----------|--------|----------|---------------|----------------------------------------------------|\n| title     | string | yes      | \"Winter Sale\" | Display name of the list to be displayed in system |\n\n#### `uuid` parameter\n\nListing object is by default equiped with randomly generate `uuid` attribute.\nIt's purpose is to be Listing unique indentifier used when fetchin vehicles on external websites\nthrough the API.\n\n*NOTE:* `uuid` value cannot be modified directly through the api calls.",
          "transitions": [
            {
              "title": "Request UUID header",
              "permalink": "t~models~listing~get~listings~header",
              "method": "GET",
              "path": "/listings?header",
              "meta": {
                "resource": {
                  "title": "Listing",
                  "permalink": "r~models~listing"
                },
                "group": {
                  "title": "Models",
                  "permalink": "g~models"
                }
              }
            },
            {
              "title": "Get All Listings",
              "permalink": "t~models~listing~get~listings",
              "method": "GET",
              "path": "/listings",
              "meta": {
                "resource": {
                  "title": "Listing",
                  "permalink": "r~models~listing"
                },
                "group": {
                  "title": "Models",
                  "permalink": "g~models"
                }
              }
            },
            {
              "title": "Show one listing",
              "permalink": "t~models~listing~get~listings~id",
              "method": "GET",
              "path": "/listings/{id}",
              "meta": {
                "resource": {
                  "title": "Listing",
                  "permalink": "r~models~listing"
                },
                "group": {
                  "title": "Models",
                  "permalink": "g~models"
                }
              }
            },
            {
              "title": "Create Listing",
              "permalink": "t~models~listing~post~listings",
              "method": "POST",
              "path": "/listings",
              "meta": {
                "resource": {
                  "title": "Listing",
                  "permalink": "r~models~listing"
                },
                "group": {
                  "title": "Models",
                  "permalink": "g~models"
                }
              }
            },
            {
              "title": "Update Listing",
              "permalink": "t~models~listing~patch~listings~id",
              "method": "PATCH",
              "path": "/listings/{id}",
              "meta": {
                "resource": {
                  "title": "Listing",
                  "permalink": "r~models~listing"
                },
                "group": {
                  "title": "Models",
                  "permalink": "g~models"
                }
              }
            },
            {
              "title": "Delete Listing",
              "permalink": "t~models~listing~delete~listings~id",
              "method": "DELETE",
              "path": "/listings/{id}",
              "meta": {
                "resource": {
                  "title": "Listing",
                  "permalink": "r~models~listing"
                },
                "group": {
                  "title": "Models",
                  "permalink": "g~models"
                }
              }
            },
            {
              "title": "(Un)Publishing Vehicles",
              "permalink": "t~models~listing~put~listings~id~vehicle~vehicle~id",
              "method": "PUT",
              "path": "/listings/:id/vehicle/:vehicle_id",
              "meta": {
                "resource": {
                  "title": "Listing",
                  "permalink": "r~models~listing"
                },
                "group": {
                  "title": "Models",
                  "permalink": "g~models"
                }
              }
            }
          ]
        },
        {
          "title": "Nameplate",
          "permalink": "r~models~nameplate",
          "description": "Represents Nameplate like Jaguar XE or Land Rover Discovery\n\nNote: Requires `Brand` association to exist",
          "transitions": [
            {
              "title": "Get All Nameplates",
              "permalink": "t~models~nameplate~get~nameplates",
              "method": "GET",
              "path": "/nameplates",
              "meta": {
                "resource": {
                  "title": "Nameplate",
                  "permalink": "r~models~nameplate"
                },
                "group": {
                  "title": "Models",
                  "permalink": "g~models"
                }
              }
            },
            {
              "title": "Show one nameplate",
              "permalink": "t~models~nameplate~get~nameplates~id",
              "method": "GET",
              "path": "/nameplates/{id}",
              "meta": {
                "resource": {
                  "title": "Nameplate",
                  "permalink": "r~models~nameplate"
                },
                "group": {
                  "title": "Models",
                  "permalink": "g~models"
                }
              }
            },
            {
              "title": "Create Nameplate",
              "permalink": "t~models~nameplate~post~nameplates",
              "method": "POST",
              "path": "/nameplates",
              "meta": {
                "resource": {
                  "title": "Nameplate",
                  "permalink": "r~models~nameplate"
                },
                "group": {
                  "title": "Models",
                  "permalink": "g~models"
                }
              }
            },
            {
              "title": "Update Nameplate",
              "permalink": "t~models~nameplate~patch~nameplates~id",
              "method": "PATCH",
              "path": "/nameplates/{id}",
              "meta": {
                "resource": {
                  "title": "Nameplate",
                  "permalink": "r~models~nameplate"
                },
                "group": {
                  "title": "Models",
                  "permalink": "g~models"
                }
              }
            },
            {
              "title": "Delete Nameplate",
              "permalink": "t~models~nameplate~delete~nameplates~id",
              "method": "DELETE",
              "path": "/nameplates/{id}",
              "meta": {
                "resource": {
                  "title": "Nameplate",
                  "permalink": "r~models~nameplate"
                },
                "group": {
                  "title": "Models",
                  "permalink": "g~models"
                }
              }
            }
          ]
        },
        {
          "title": "Photo",
          "permalink": "r~models~photo",
          "description": "",
          "transitions": [
            {
              "title": "Get All Photos",
              "permalink": "t~models~photo~get~photos",
              "method": "GET",
              "path": "/photos",
              "meta": {
                "resource": {
                  "title": "Photo",
                  "permalink": "r~models~photo"
                },
                "group": {
                  "title": "Models",
                  "permalink": "g~models"
                }
              }
            },
            {
              "title": "Show one photo",
              "permalink": "t~models~photo~get~photos~id",
              "method": "GET",
              "path": "/photos/{id}",
              "meta": {
                "resource": {
                  "title": "Photo",
                  "permalink": "r~models~photo"
                },
                "group": {
                  "title": "Models",
                  "permalink": "g~models"
                }
              }
            },
            {
              "title": "Create Photo",
              "permalink": "t~models~photo~post~photos",
              "method": "POST",
              "path": "/photos",
              "meta": {
                "resource": {
                  "title": "Photo",
                  "permalink": "r~models~photo"
                },
                "group": {
                  "title": "Models",
                  "permalink": "g~models"
                }
              }
            },
            {
              "title": "Update Photo",
              "permalink": "t~models~photo~patch~photos~id",
              "method": "PATCH",
              "path": "/photos/{id}",
              "meta": {
                "resource": {
                  "title": "Photo",
                  "permalink": "r~models~photo"
                },
                "group": {
                  "title": "Models",
                  "permalink": "g~models"
                }
              }
            },
            {
              "title": "Delete Photo",
              "permalink": "t~models~photo~delete~photos~id",
              "method": "DELETE",
              "path": "/photos/{id}",
              "meta": {
                "resource": {
                  "title": "Photo",
                  "permalink": "r~models~photo"
                },
                "group": {
                  "title": "Models",
                  "permalink": "g~models"
                }
              }
            }
          ]
        },
        {
          "title": "Vehicle",
          "permalink": "r~models~vehicle",
          "description": "Represents actual Vehicle (Car) to be displayed in system\n\n## Mandatory Relationships\n\n- Nameplate\n\n- Owner: Company listing this Vehicle\n\n- Color\n\n## Attributes\n\n| param               | example       | type          | required | description                                  |\n|-------------------  |---------------|---------------|----------|----------------------------------------------|\n| `version`           | 'HSE'         | string        | yes      | Version/Trim Level name/description          |\n| `drivetrain`        | 'P300 AWD'    | string        | yes      | Drivetrain (Engine, gearbox etc) description |\n| `short_description` | 'Lorem ipsum' | string        | no       | Short description paragraph                  |\n| `production_year`   | 2020          | integer       | no       | Year when vehicle was manufacturedd          |\n| `msrp_price`        | 123000        | decimal(18,2) | no       | Retailer price                               |\n| `sale_price`        | 120000        | decimal(18,2) | no       | Sale Price                                   |\n| `monthly_price`     | 2500.01       | decimal(18,2) | no       | Monthly price                                |\n| `long_description`  | 'Lorem ...'   | string        | no       | Full description copy (potentialy HTML)      |\n| `state`             | 'new'         | enum          | yes      | Vehicle state. New, User or Approved         |\n| `status`            | 'stock'       | enum          | yes      | Stock status of the Vehicle                  |\n| `delivery_date`     | 2020-02-02    | date          | no       | Date of delivery                             |\n| `transsmision`      | 'auto'        | enum          | yes      | type of transmission, auto by default        |\n| `vin`               | 'XXX'         | string        | no       | Vehicle Vin number                           |\n| `mileage`           | 123000        | number        | yes      | vehicle mileage in ower company units        |\n| `engine_capacity`   | 1999          | number        | no       | engine capacity in ccm                       |\n| `battery_capacity`  | 2020          | number        | no       | battery capacity                             |\n| `engine_type`       | 2020          | number        | yes      | kind of engine, as a strings array           |\n| `power`             | 2020          | number        | no       | vehicle power in ower company units          |\n| `video_url`         | 2020          | number        | no       | youtube video url                            |\n| `attachment`        | 2020          | string        | no       | signed_id of the attachment blob             |\n| `created_at`        | 2020          | timestamp     | n/a      | Record creation date, auto-generated         |\n| `updated_at`        | 2020          | timestamp     | n/a      | Record lat update date, auto-generated       |\n\n## Values for enums\n\n### `state` values\n\n- `new`\n\n- `used`\n\n- `approved`\n\n### `status` values\n\n- `stock` - Vehicles in stock\n\n- `delivery` - Vehicle in delivery\n\n- `reserved` - Reserved Vehicle (will be user later)\n\n- `in_production` - Vehicle in production\n\n- `available_soon` - Vehicle will be available soon\n\n- `sold` - Vehicle has been sold\n\n### `transsmision` values\n\n- `auto`\n\n- `manual`\n\n### `engine_type` values\n\n- `petrol`\n\n- `diesel`\n\n- `bev` - Electric Vehicle\n\n- `mhev` - Mild Hybrid\n\n- `phev` - Plug-In Hybrid",
          "transitions": [
            {
              "title": "Features Objects",
              "permalink": "t~models~vehicle~patch~vehicles~features",
              "method": "PATCH",
              "path": "/vehicles.features",
              "meta": {
                "resource": {
                  "title": "Vehicle",
                  "permalink": "r~models~vehicle"
                },
                "group": {
                  "title": "Models",
                  "permalink": "g~models"
                }
              }
            },
            {
              "title": "Filtering",
              "permalink": "t~models~vehicle~get~vehicles~filter~xxx~xxx",
              "method": "GET",
              "path": "/vehicles?filter[xxx]=xxx",
              "meta": {
                "resource": {
                  "title": "Vehicle",
                  "permalink": "r~models~vehicle"
                },
                "group": {
                  "title": "Models",
                  "permalink": "g~models"
                }
              }
            },
            {
              "title": "Sorting",
              "permalink": "t~models~vehicle~get~vehicles~sort~xxx",
              "method": "GET",
              "path": "/vehicles?sort=xxx",
              "meta": {
                "resource": {
                  "title": "Vehicle",
                  "permalink": "r~models~vehicle"
                },
                "group": {
                  "title": "Models",
                  "permalink": "g~models"
                }
              }
            },
            {
              "title": "Request UUID header",
              "permalink": "t~models~vehicle~get~colors~header",
              "method": "GET",
              "path": "/colors?header",
              "meta": {
                "resource": {
                  "title": "Vehicle",
                  "permalink": "r~models~vehicle"
                },
                "group": {
                  "title": "Models",
                  "permalink": "g~models"
                }
              }
            },
            {
              "title": "Pagination",
              "permalink": "t~models~vehicle~get~vehicles~page~1",
              "method": "GET",
              "path": "/vehicles?page=1",
              "meta": {
                "resource": {
                  "title": "Vehicle",
                  "permalink": "r~models~vehicle"
                },
                "group": {
                  "title": "Models",
                  "permalink": "g~models"
                }
              }
            },
            {
              "title": "Attach Photos to Vehicle",
              "permalink": "t~models~vehicle~patch~vehicle~include~photos",
              "method": "PATCH",
              "path": "/vehicle?include=photos",
              "meta": {
                "resource": {
                  "title": "Vehicle",
                  "permalink": "r~models~vehicle"
                },
                "group": {
                  "title": "Models",
                  "permalink": "g~models"
                }
              }
            },
            {
              "title": "Get All Vehicles",
              "permalink": "t~models~vehicle~get~vehicles",
              "method": "GET",
              "path": "/vehicles",
              "meta": {
                "resource": {
                  "title": "Vehicle",
                  "permalink": "r~models~vehicle"
                },
                "group": {
                  "title": "Models",
                  "permalink": "g~models"
                }
              }
            },
            {
              "title": "Show one vehicle",
              "permalink": "t~models~vehicle~get~vehicles~id",
              "method": "GET",
              "path": "/vehicles/{id}",
              "meta": {
                "resource": {
                  "title": "Vehicle",
                  "permalink": "r~models~vehicle"
                },
                "group": {
                  "title": "Models",
                  "permalink": "g~models"
                }
              }
            },
            {
              "title": "Create Vehicle",
              "permalink": "t~models~vehicle~post~vehicles",
              "method": "POST",
              "path": "/vehicles",
              "meta": {
                "resource": {
                  "title": "Vehicle",
                  "permalink": "r~models~vehicle"
                },
                "group": {
                  "title": "Models",
                  "permalink": "g~models"
                }
              }
            },
            {
              "title": "Update Vehicle",
              "permalink": "t~models~vehicle~patch~vehicles~id",
              "method": "PATCH",
              "path": "/vehicles/{id}",
              "meta": {
                "resource": {
                  "title": "Vehicle",
                  "permalink": "r~models~vehicle"
                },
                "group": {
                  "title": "Models",
                  "permalink": "g~models"
                }
              }
            },
            {
              "title": "Delete Vehicle",
              "permalink": "t~models~vehicle~delete~vehicles~id",
              "method": "DELETE",
              "path": "/vehicles/{id}",
              "meta": {
                "resource": {
                  "title": "Vehicle",
                  "permalink": "r~models~vehicle"
                },
                "group": {
                  "title": "Models",
                  "permalink": "g~models"
                }
              }
            }
          ]
        },
        {
          "title": "VistaFile",
          "permalink": "r~models~vistafile",
          "description": "",
          "transitions": [
            {
              "title": "Request UUID header",
              "permalink": "t~models~vistafile~post~vista~files~features",
              "method": "POST",
              "path": "/vista_files/features",
              "meta": {
                "resource": {
                  "title": "VistaFile",
                  "permalink": "r~models~vistafile"
                },
                "group": {
                  "title": "Models",
                  "permalink": "g~models"
                }
              }
            },
            {
              "title": "Extract Vehicle details from Vista file",
              "permalink": "t~models~vistafile~post~vista~files~features",
              "method": "POST",
              "path": "/vista_files/features",
              "meta": {
                "resource": {
                  "title": "VistaFile",
                  "permalink": "r~models~vistafile"
                },
                "group": {
                  "title": "Models",
                  "permalink": "g~models"
                }
              }
            }
          ]
        },
        {
          "title": "Vocabulary",
          "permalink": "r~models~vocabulary",
          "description": "Represents vocabulary (and translations) stored in the database and used in feature suggestions. In fact, the database representation of `Vocabulary` is `FeatureSuggestion` but to make it more adjusted to the actual needs of the Vocabulary tab of the application, it is a separate resource in the API with separate data structure definition.",
          "transitions": [
            {
              "title": "Get All Vocabulary entries",
              "permalink": "t~models~vocabulary~get~vocabulary",
              "method": "GET",
              "path": "/vocabulary",
              "meta": {
                "resource": {
                  "title": "Vocabulary",
                  "permalink": "r~models~vocabulary"
                },
                "group": {
                  "title": "Models",
                  "permalink": "g~models"
                }
              }
            },
            {
              "title": "Create Vocabulary resource",
              "permalink": "t~models~vocabulary~post~vocabulary",
              "method": "POST",
              "path": "/vocabulary",
              "meta": {
                "resource": {
                  "title": "Vocabulary",
                  "permalink": "r~models~vocabulary"
                },
                "group": {
                  "title": "Models",
                  "permalink": "g~models"
                }
              }
            },
            {
              "title": "Destroy Vocabulary entry",
              "permalink": "t~models~vocabulary~delete~vocabulary~id",
              "method": "DELETE",
              "path": "/vocabulary/{id}",
              "meta": {
                "resource": {
                  "title": "Vocabulary",
                  "permalink": "r~models~vocabulary"
                },
                "group": {
                  "title": "Models",
                  "permalink": "g~models"
                }
              }
            },
            {
              "title": "Update Vocabulary resource",
              "permalink": "t~models~vocabulary~patch~vocabulary~code",
              "method": "PATCH",
              "path": "/vocabulary/{code}",
              "meta": {
                "resource": {
                  "title": "Vocabulary",
                  "permalink": "r~models~vocabulary"
                },
                "group": {
                  "title": "Models",
                  "permalink": "g~models"
                }
              }
            }
          ]
        }
      ]
    },
    {
      "title": "MyJLR API",
      "permalink": "g~myjlr~api",
      "description": "Public MyJLR API enpoints to use in MyJLR Customer portal widgets",
      "resources": [
        {
          "title": "Vehicle",
          "permalink": "r~myjlr~api~vehicle",
          "description": "",
          "transitions": [
            {
              "title": "Fetch Vehicle data",
              "permalink": "t~myjlr~api~vehicle~get~my~jlr~listing~uuid~vehicle~vehicle~id",
              "method": "GET",
              "path": "/my_jlr/listing/{uuid}/vehicle/{vehicle_id}",
              "meta": {
                "resource": {
                  "title": "Vehicle",
                  "permalink": "r~myjlr~api~vehicle"
                },
                "group": {
                  "title": "MyJLR API",
                  "permalink": "g~myjlr~api"
                }
              }
            }
          ]
        }
      ]
    },
    {
      "title": "Public API",
      "permalink": "g~public~api",
      "description": "Public API enpoints to use in widget",
      "resources": [
        {
          "title": "Brands",
          "permalink": "r~public~api~brands",
          "description": "Represents Brand like Jaguar or Land Rover",
          "transitions": [
            {
              "title": "Get All Brands",
              "permalink": "t~public~api~brands~get~public~api~brands",
              "method": "GET",
              "path": "/public_api/brands",
              "meta": {
                "resource": {
                  "title": "Brands",
                  "permalink": "r~public~api~brands"
                },
                "group": {
                  "title": "Public API",
                  "permalink": "g~public~api"
                }
              }
            },
            {
              "title": "Get Nameplates by Brand",
              "permalink": "t~public~api~brands~get~public~api~brands~id~nameplates",
              "method": "GET",
              "path": "/public_api/brands/{id}/nameplates",
              "meta": {
                "resource": {
                  "title": "Brands",
                  "permalink": "r~public~api~brands"
                },
                "group": {
                  "title": "Public API",
                  "permalink": "g~public~api"
                }
              }
            }
          ]
        },
        {
          "title": "Vehicles",
          "permalink": "r~public~api~vehicles",
          "description": "# Overview\n\n`/public_api` section is intended to be freely used on all websites and provide data to CarsInventory widgets.\n\nIts behaviour is mostly modeled based on private `/vehicles` controller but lacks authorization and is\noptimized for typical website usecases.\n\nBasic required attribute to use it is `Listing` object `uuid` value.",
          "transitions": [
            {
              "title": "Filtering",
              "permalink": "t~public~api~vehicles~get~public~api~listing~uuid~filter~xxx~xxx",
              "method": "GET",
              "path": "/public_api/listing/{uuid}?filter[xxx]=xxx",
              "meta": {
                "resource": {
                  "title": "Vehicles",
                  "permalink": "r~public~api~vehicles"
                },
                "group": {
                  "title": "Public API",
                  "permalink": "g~public~api"
                }
              }
            },
            {
              "title": "Sharing",
              "permalink": "t~public~api~vehicles~get~public~api~vehicles~id~share",
              "method": "GET",
              "path": "/public_api/vehicles/{id}/share",
              "meta": {
                "resource": {
                  "title": "Vehicles",
                  "permalink": "r~public~api~vehicles"
                },
                "group": {
                  "title": "Public API",
                  "permalink": "g~public~api"
                }
              }
            },
            {
              "title": "Sorting",
              "permalink": "t~public~api~vehicles~get~public~api~listing~uuid~sort~xxx",
              "method": "GET",
              "path": "/public_api/listing/{uuid}?sort=xxx",
              "meta": {
                "resource": {
                  "title": "Vehicles",
                  "permalink": "r~public~api~vehicles"
                },
                "group": {
                  "title": "Public API",
                  "permalink": "g~public~api"
                }
              }
            },
            {
              "title": "Pagination",
              "permalink": "t~public~api~vehicles~get~public~api~listing~uuid~page~1",
              "method": "GET",
              "path": "/public_api/listing/{uuid}?page=1",
              "meta": {
                "resource": {
                  "title": "Vehicles",
                  "permalink": "r~public~api~vehicles"
                },
                "group": {
                  "title": "Public API",
                  "permalink": "g~public~api"
                }
              }
            },
            {
              "title": "Get All Vehicle for Listing",
              "permalink": "t~public~api~vehicles~get~public~api~listing~uuid",
              "method": "GET",
              "path": "/public_api/listing/{uuid}",
              "meta": {
                "resource": {
                  "title": "Vehicles",
                  "permalink": "r~public~api~vehicles"
                },
                "group": {
                  "title": "Public API",
                  "permalink": "g~public~api"
                }
              }
            },
            {
              "title": "Show one Vehicle",
              "permalink": "t~public~api~vehicles~get~public~api~listing~uuid~vehicle~vehicle~id",
              "method": "GET",
              "path": "/public_api/listing/{uuid}/vehicle/{vehicle_id}",
              "meta": {
                "resource": {
                  "title": "Vehicles",
                  "permalink": "r~public~api~vehicles"
                },
                "group": {
                  "title": "Public API",
                  "permalink": "g~public~api"
                }
              }
            }
          ]
        }
      ]
    },
    {
      "title": "Suggestions",
      "permalink": "g~suggestions",
      "description": "# Overview\n\nSuggestions are entries in the dictionaries that are inteded to be used as suggestions for user\nfilling out the Vechile form either while adding or editing the Vehicles.\n\nThe `Suggestions` are updated each time Vehicle is saved to database (created or updated)\n\nSuggestions are inherited through the companies hierarchy. If Importer already has one `Suggestion` in the database the\nDealers will see this `Suggestion` as well and it will not be automatically duplicated when adding a `Vehicle`\n\n**NOTE**: Due to this behaviour `X-Comapny-UUID` header is required to filter suggestions based on `Company` ownership.\n\n`SimpleSuggestion` will handle only `drivetrain` and `version` fields.\n`Vechile` Features attrbiutes are handled through similiar but a bit more complex object called `FeatureSuggestion`\n\n## The `depth` attribute\n\nEach `Company` has it's depth or level in the companies tree hierarchy. `depth` attribute of the `Suggestion` objects reflect depth\nof the company owning the returned suggestions. It is used as a metric of relevance.\n\nFor example lets consider Company A owned by Company B which is owned by Company C which is not owned by anyone.\nCompany C will have `depth` equal 0. Company A's `depth` will equal 2.\nSo when we fetch Suggestions for a Company A we will inherit the Suggestion from parent company and it's parent company etc. But the most relevant suggestion will always be the one owned by Company A.",
      "resources": [
        {
          "title": "FeatureSuggestions",
          "permalink": "r~suggestions~featuresuggestions",
          "description": "# Overview\n\nFeatureSuggestions are dictionary suggestions entries which are inteded\nto be used as suggestions for user filling out the Vechile form features section\neither while adding or editing the Cars.\n\nThe `FeatureSuggestions` list is updated each time Vehicle is saved to database (created or updated).\nThay are not designed to be manipulated through the API directly.\n\n**NOTE**: Due to this behaviour `X-Comapny-UUID` header is required to filter suggestions based on `Company` ownership.\n\nAs their intended used is a table with `Vehicle` features they always contain `label` attrbiute and\noptionally can contain `code` and `category` attributes as well depending on the data filed in the vehicle.",
          "transitions": [
            {
              "title": "Get Suggestions by Code",
              "permalink": "t~suggestions~featuresuggestions~get~suggestions~features~code~code~query",
              "method": "GET",
              "path": "/suggestions/features/code/{code_query}",
              "meta": {
                "resource": {
                  "title": "FeatureSuggestions",
                  "permalink": "r~suggestions~featuresuggestions"
                },
                "group": {
                  "title": "Suggestions",
                  "permalink": "g~suggestions"
                }
              }
            },
            {
              "title": "Get Suggestions by Label",
              "permalink": "t~suggestions~featuresuggestions~get~suggestions~features~label~label~query",
              "method": "GET",
              "path": "/suggestions/features/label/{label_query}",
              "meta": {
                "resource": {
                  "title": "FeatureSuggestions",
                  "permalink": "r~suggestions~featuresuggestions"
                },
                "group": {
                  "title": "Suggestions",
                  "permalink": "g~suggestions"
                }
              }
            }
          ]
        },
        {
          "title": "SimpleSuggestions",
          "permalink": "r~suggestions~simplesuggestions",
          "description": "# Overview\n\nSimpleSuggestions are simple string based dictionary suggestions which are inteded\nto be used as suggestions for user filling out the Vechile form either while adding or editing the Cars\n\nThe `SimpleSuggestion`s list is updated each time Vehicle is saved to database (created or updated).\nThay are not designed to be manipulated through the API directly.\n\nSuggestions are inherited through the companies hierarchy. If Importer already has one `Suggestion`\nin the database the Dealers will see this `Suggestion` as well and it will not be automatically\nduplicated when adding a `Vehicle`\n\n**NOTE**: Due to this behaviour `X-Comapny-UUID` header is required to filter suggestions based on `Company` ownership.\n\n`SimpleSuggestion` will handle only `drivetrain` and `version` fields.",
          "transitions": [
            {
              "title": "Get Version Suggestions",
              "permalink": "t~suggestions~simplesuggestions~get~suggestions~versions",
              "method": "GET",
              "path": "/suggestions/versions",
              "meta": {
                "resource": {
                  "title": "SimpleSuggestions",
                  "permalink": "r~suggestions~simplesuggestions"
                },
                "group": {
                  "title": "Suggestions",
                  "permalink": "g~suggestions"
                }
              }
            },
            {
              "title": "Get Drivetrains Suggestions",
              "permalink": "t~suggestions~simplesuggestions~get~suggestions~drivetrains",
              "method": "GET",
              "path": "/suggestions/drivetrains",
              "meta": {
                "resource": {
                  "title": "SimpleSuggestions",
                  "permalink": "r~suggestions~simplesuggestions"
                },
                "group": {
                  "title": "Suggestions",
                  "permalink": "g~suggestions"
                }
              }
            }
          ]
        }
      ]
    },
    {
      "title": "Turkish Integration API",
      "permalink": "g~turkish~integration~api",
      "description": "API for external integration for Turkish market",
      "resources": [
        {
          "title": "Vehicles Integration",
          "permalink": "r~turkish~integration~api~vehicles~integration",
          "description": "",
          "transitions": [
            {
              "title": "Authentication",
              "permalink": "t~turkish~integration~api~vehicles~integration~post~integration~api~turkey~vehicles~auth",
              "method": "POST",
              "path": "/integration_api/turkey/vehicles   [auth]",
              "meta": {
                "resource": {
                  "title": "Vehicles Integration",
                  "permalink": "r~turkish~integration~api~vehicles~integration"
                },
                "group": {
                  "title": "Turkish Integration API",
                  "permalink": "g~turkish~integration~api"
                }
              }
            },
            {
              "title": "Create Vehicle",
              "permalink": "t~turkish~integration~api~vehicles~integration~post~integration~api~turkey~vehicles",
              "method": "POST",
              "path": "/integration_api/turkey/vehicles",
              "meta": {
                "resource": {
                  "title": "Vehicles Integration",
                  "permalink": "r~turkish~integration~api~vehicles~integration"
                },
                "group": {
                  "title": "Turkish Integration API",
                  "permalink": "g~turkish~integration~api"
                }
              }
            },
            {
              "title": "Delete Vehicle",
              "permalink": "t~turkish~integration~api~vehicles~integration~delete~integration~api~turkey~vehicles~vin",
              "method": "DELETE",
              "path": "/integration_api/turkey/vehicles/{vin}",
              "meta": {
                "resource": {
                  "title": "Vehicles Integration",
                  "permalink": "r~turkish~integration~api~vehicles~integration"
                },
                "group": {
                  "title": "Turkish Integration API",
                  "permalink": "g~turkish~integration~api"
                }
              }
            }
          ]
        }
      ]
    }
  ],
  "resources": [],
  "config": {
    "overrides": {},
    "playground": {
      "enabled": false
    },
    "basePath": "/"
  },
  "uuids": {
    "t~integration~api~colors~list~get~integration~api~colors~auth": "02i29SIMuw2yEhtQKKZ_k",
    "t~integration~api~colors~list~get~integration~api~colors": "mQnbiFC7zbt4TRdt6Mur5",
    "t~integration~api~nameplates~list~get~integration~api~nameplates~auth": "3cWAXXN-T_fAxwtSZBacO",
    "t~integration~api~nameplates~list~get~integration~api~nameplates": "x8h4KZ52Td_X4-fjs3o2T",
    "t~integration~api~vehicles~integration~post~integration~api~vehicles~auth": "7cR8V5ElExqavf7eVDDiC",
    "t~integration~api~vehicles~integration~post~integration~api~vehicles": "LMo13rFYq8Ct3-4BpvP7Y",
    "t~management~api~companies~get~management~api~companies": "FBF2vN7_Z1wZ0Iob2qcgZ",
    "t~models~brand~get~brands": "brQdV2rHcu1KiyUvzpLhe",
    "t~models~brand~get~brands~id": "zBPBVv29OIe5FqaKDhPz_",
    "t~models~brand~post~brands": "Xj1W3bQrzFpi2LuM5_cvn",
    "t~models~brand~patch~brands~id": "o7EIbz7F12x_xdpo0Tz7_",
    "t~models~brand~delete~brands~id": "QVab1eJTL_dQk37W_HtnH",
    "t~models~buttonset~get~buttons~header": "fmIzW4liv_xZjVGquiI9q",
    "t~models~buttonset~get~button~sets": "EbBNbRKXDNLKu78jYWOa8",
    "t~models~buttonset~get~button~sets~id": "Hcc3_XXz2OSu5cTnPIRrA",
    "t~models~buttonset~post~button~sets": "lsiiWa8eHgVaEN11QVI1z",
    "t~models~buttonset~patch~button~sets~id": "lvOU2v0HBQ3dz9jKe5Pcq",
    "t~models~buttonset~delete~button~sets~id": "_NmnP5PLF2tWRqegbf7C4",
    "t~models~color~get~colors~header": "AYs4GwJfWRzSGSz0gcIfQ",
    "t~models~color~get~colors": "RNZRix3NmOa5O4qidkCC-",
    "t~models~color~get~colors~id": "EILtjlbn5BxcqqLn-L9xE",
    "t~models~color~post~colors": "ObsFk9Un53Pju6lXEw_qR",
    "t~models~color~patch~colors~id": "35aUPKk3BOLNSoaOzqF50",
    "t~models~color~delete~colors~id": "PlDe9gC4ZEZUGgkpPN6rQ",
    "t~models~company~get~companys~header": "eyP2JrYiNvhihtQSBBsgT",
    "t~models~company~get~companies": "ZA1zAKp-4bFKU2ExaCmb7",
    "t~models~company~get~companies~time~zones~country~code": "t5gaIC4AmQSTXvJQDbO9K",
    "t~models~company~get~company": "ZRg6-XPBPdUOlp-wJ-mCT",
    "t~models~company~post~companies": "T6gWCe7YievqZWAjgGl0U",
    "t~models~company~patch~company": "LQi56QtjK0MmzKiG9PVCc",
    "t~models~listing~get~listings~header": "I3ntUpTK9KcNXdJDwIOho",
    "t~models~listing~get~listings": "L6pOzjblVsdrp7JFNnJHD",
    "t~models~listing~get~listings~id": "DL6wgIdIQSzQE8rgcoe64",
    "t~models~listing~post~listings": "u2HZGr8RnNmJvOqFTA-Pa",
    "t~models~listing~patch~listings~id": "q4Ev2Qo0raOCsOnMuCDut",
    "t~models~listing~delete~listings~id": "2SWrHipJEw10_sM_VrEP9",
    "t~models~listing~put~listings~id~vehicle~vehicle~id": "l7jajMzeqR_D3WTMb8oX8",
    "t~models~nameplate~get~nameplates": "SwkqzoWAYdLbmvztEMUkF",
    "t~models~nameplate~get~nameplates~id": "vJ0-nfuaYwc6x6RTiZ8Kz",
    "t~models~nameplate~post~nameplates": "FINm1VM9N_bpec3vn-HBE",
    "t~models~nameplate~patch~nameplates~id": "cYl2KNesEtNR-toqYa2Cp",
    "t~models~nameplate~delete~nameplates~id": "Uf1x6cRCwibhohZIQMGUl",
    "t~models~photo~get~photos": "sHTb3QmvncjwUSVbvXO8o",
    "t~models~photo~get~photos~id": "DfKHlK8XNBgfJH9A2cXlM",
    "t~models~photo~post~photos": "0CkvNls7cDuzFtA83_VMw",
    "t~models~photo~patch~photos~id": "O1tMCwYi8ODrGLUDDjRF1",
    "t~models~photo~delete~photos~id": "cAbSPsc4kkxUAguz2HQ7y",
    "t~models~vehicle~patch~vehicles~features": "LGjclVdAyTrVt3yOwa1sR",
    "t~models~vehicle~get~vehicles~filter~xxx~xxx": "xMZkurTTNEnIFTnIFpaxT",
    "t~models~vehicle~get~vehicles~sort~xxx": "k_O-0I7kXoWrisAt59kBz",
    "t~models~vehicle~get~colors~header": "Ui2lBl_xQxQByjhN5iHea",
    "t~models~vehicle~get~vehicles~page~1": "ZAhuKeaW13y0S9kBVOUHT",
    "t~models~vehicle~patch~vehicle~include~photos": "4xUZm3DKNR1G_T4cNEOv1",
    "t~models~vehicle~get~vehicles": "Qr2YtCvLrJnGxAvrVb_fe",
    "t~models~vehicle~get~vehicles~id": "_8LdC15SQ5yrPY94Dfn7c",
    "t~models~vehicle~post~vehicles": "XE-LaHzNoBYsVYbLnMOjD",
    "t~models~vehicle~patch~vehicles~id": "AgAUsRYwtQB1ok_OULi1e",
    "t~models~vehicle~delete~vehicles~id": "08hGC7QGhzQ6p8lkUSSv2",
    "t~models~vistafile~post~vista~files~features": "Dc8_RPWAEWZdMAOEJydx6",
    "t~models~vocabulary~get~vocabulary": "aQqf4diMmdWHMZyZuEl5t",
    "t~models~vocabulary~post~vocabulary": "l1--3Z1XvydPuKkxcqF4I",
    "t~models~vocabulary~delete~vocabulary~id": "0l5DQIXobOkNLIsXK4F_7",
    "t~models~vocabulary~patch~vocabulary~code": "qdj-kVRMs0znS7P2tfPMc",
    "t~myjlr~api~vehicle~get~my~jlr~listing~uuid~vehicle~vehicle~id": "lGWSkp-jKKcb7O5IgZlWw",
    "t~public~api~brands~get~public~api~brands": "RDFQOQMocTrEkYaK5IXXY",
    "t~public~api~brands~get~public~api~brands~id~nameplates": "ybaEB0LTkaNLzEcx6xPaa",
    "t~public~api~vehicles~get~public~api~listing~uuid~filter~xxx~xxx": "ji_-QTGPamxE--PK7JEAI",
    "t~public~api~vehicles~get~public~api~vehicles~id~share": "673HnuGshm6vXZzKUUUKT",
    "t~public~api~vehicles~get~public~api~listing~uuid~sort~xxx": "uB0pKm7_OisJTKS4oP8so",
    "t~public~api~vehicles~get~public~api~listing~uuid~page~1": "m-gG80bf1wrkJWD_wEKHE",
    "t~public~api~vehicles~get~public~api~listing~uuid": "-Zy8-rVFiBOgWdQ2MVV35",
    "t~public~api~vehicles~get~public~api~listing~uuid~vehicle~vehicle~id": "rmHhDs8JafOGg6bYoernZ",
    "t~suggestions~featuresuggestions~get~suggestions~features~code~code~query": "XFs46ecl-CA-7sYXw_Eoe",
    "t~suggestions~featuresuggestions~get~suggestions~features~label~label~query": "DGkaQoue6SrQ8n2mdNfd9",
    "t~suggestions~simplesuggestions~get~suggestions~versions": "g9I-_p8lvC6KTIEpTCaiR",
    "t~suggestions~simplesuggestions~get~suggestions~drivetrains": "TJfUo635UQd7Ixrp-7K1z",
    "t~turkish~integration~api~vehicles~integration~post~integration~api~turkey~vehicles~auth": "67CsdL4V06rAIdkJ7QIR9",
    "t~turkish~integration~api~vehicles~integration~post~integration~api~turkey~vehicles": "3YYCc-4_c1plJ2FBq05fo",
    "t~turkish~integration~api~vehicles~integration~delete~integration~api~turkey~vehicles~vin": "qWGADFYMG9s4I-PbyP2Ra"
  },
  "descriptionToc": []
};
export default seeds;
  